import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import policyAuthorizations from 'modules/permissions/store/collections/policyAuthorizations'
import type { PolicyTarget } from 'modules/permissions/store/collections/policyAuthorizations'

export interface ITeam {
  id: string
  description?: string
  avatar?: string
  name: string
}

class Team extends Model<ITeam> implements PolicyTarget {
  static urlRoot() {
    return '/teams'
  }

  get policyTargetClass(): string {
    return '::Team'
  }

  constructor(attr: ITeam) {
    super(attr)
    makeObservable(this, {
      canManage: computed,
    })
  }

  get canManage(): boolean {
    return policyAuthorizations.for('teams.manage', this)
  }
}

export default Team
